import { useContext, useState } from "react";
import {
  AmountItem,
  AmountList,
  AmountTitle,
  BlockAmount,
  BlockStakingAmount,
  BlockSummary,
  BlockTitle,
  ButtonListDuration,
  ContentDuration,
  ContentInnerLeft,
  ContentInnerRight,
  ContentRightInner,
  DurationHint,
} from "./styled";
import Duration from "../Duration";
import {
  ClickMaxAmount,
  SwapContent,
  SwapInput,
  SwapInputTitle,
  SwapInputValue,
  SwapInputWrapper,
} from "../../Swap/styled";
import { useMediaQuery } from "react-responsive";

import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";
import { Controller, useForm } from "react-hook-form";
import wallet_icon from "../../../assets/Staking/icn_wallet.svg";
import TitleCommon from "../../../components/Common/Title";
import lightning from "../../../assets/Dashboard/Stake/lightning.png";
import lightning_light from "../../../assets/Dashboard/Stake/lightning_light.png";
import {
  ButtonCommon,
  ContextProviderWrapper,
  convertFixed,
  fieldNormalizer,
  InputCommon,
} from "@kibble-exchange/uikit";
import { useBalance } from "../../../hooks/useBalance";
import { debounce } from "lodash";
import { buyAction, claimAction } from "../../../hooks/usePresale";
import { Address } from "@ton/core";
import { PRESALE_ADDRESS } from "constant";
import { useSelector } from "react-redux";
import { useDispatch } from "store/store";
import { getPresaleWalletData, Presale } from "wrappers/presale";
import { getGlobalDataPresale, getUserDataPresale } from "store/features/presaleSlice";

export const shorten = (str: String) => {
  return str.substring(0, 6) + "..." + str.slice(-6);
};

const Stake = () => {
  const { globalData, userData } = useSelector((state: any) => state.presale);
  const { theme } = useContext(ContextProviderWrapper)!;
  const [activeDuration, setActiveDuration] = useState(1);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 500 });
  const address = useTonAddress();
  const { tonBalance } = useBalance();
  const [tonconnect] = useTonConnectUI();
  const [buyAmount, setBuyAmount] = useState("0");
  const presaleContract = Presale.createFromAddress(Address.parse(PRESALE_ADDRESS));
  const setMaxAmount = () => {
    setBuyAmount(String(tonBalance));
  };
  const { control } = useForm({ mode: "onChange" });

  const countDecimals = (value: any) => {
    const valueAsString = String(value);
    const splitValue = valueAsString.split(".");
    return splitValue.length > 1 ? splitValue[1].length : 0;
  };
  const handleBuyAmount = (e: any) => {
    let value = e.target.value;

    // Replace commas with periods
    value = value.replace(/,/g, ".");

    // If the input is empty, set the value to an empty string
    if (value === "") {
      setBuyAmount(value);
      return;
    }

    // Ensure the value is either a number or a decimal point
    const isValidNumber = /^[0-9]*\.?[0-9]*$/;

    if (isValidNumber.test(value)) {
      const decimalsCount = countDecimals(value);

      if (decimalsCount <= 9) {
        setBuyAmount(value);
      }
    }
  };

  const calcClaimable = () => {
    if (userData?.is_claimed == 1) return "Already claimed";
    return userData ? Number(userData.jetton_amount).toFixed(3) : "---";
  };
  const handleBuyToken = () => {
    buyAction(presaleContract, address, tonconnect, buyAmount, Address.parse(PRESALE_ADDRESS));
    dispatch(getGlobalDataPresale());
    dispatch(getUserDataPresale(address));
  };

  const handleClaimToken = () => {
    claimAction(presaleContract, address, tonconnect, Address.parse(PRESALE_ADDRESS ?? ""));
    dispatch(getGlobalDataPresale());
    dispatch(getUserDataPresale(address));
  };

  const DataDurationList = [
    {
      id: 1,
      duration: {
        title: "Duration",
        value: "7 days",
      },
      presalePrice: {
        title: "Presale Price",
        value: (1 / Number(globalData.price)).toFixed(4) + " TON",
      },
      launchPrice: {
        title: "Launch Price",
        value: "0.4255 TON",
      },
      totalSoldAmount: {
        title: "Sold amount",
        value: (Number(globalData.cap) - Number(globalData.total_supply)).toFixed(3),
      },
      softcap: {
        title: "SoftCap",
        value: Number(globalData.cap),
      },
      exchange: {
        title: "Exchange rate",
        value: "TBA",
      },
      poolAddress: {
        title: "Contract address",
        value: PRESALE_ADDRESS,
      },
      balance: {
        title: "Your TON Balance",
        value: tonBalance && String(tonBalance),
      },
      claimable: {
        title: "Your Claimable",
        value: calcClaimable(),
      },
      staked: {
        title: "Your Staked amount",
        value: userData ? Number(userData.staked_amount) + " TON" : "---",
      },
    },
  ];

  return (
    <>
      <ContentRightInner>
        <div>
          <BlockStakingAmount>
            <SwapContent>
              <SwapInput>
                <SwapInputTitle>
                  <p>Amount</p>
                  <ClickMaxAmount>
                    {!isMobile && "Available: "} {tonBalance.toString()} |{" "}
                    <span onClick={setMaxAmount}>MAX</span>
                  </ClickMaxAmount>
                </SwapInputTitle>
                <SwapInputWrapper
                  style={{
                    cursor: address ? "pointer" : "not-allowed",
                  }}
                  active={1 > 0}>
                  <Controller
                    name="fromAmount"
                    control={control}
                    render={({ field }: any) => (
                      <SwapInputValue>
                        <InputCommon
                          {...field}
                          disabled={address ? false : true}
                          onChange={handleBuyAmount}
                          // onFocus={handleResetValueFrom}
                          placeHolder={"0"}
                          value={buyAmount}
                        />
                      </SwapInputValue>
                    )}
                  />
                  {/* ---------- */}
                </SwapInputWrapper>
              </SwapInput>
            </SwapContent>
          </BlockStakingAmount>

          {/* <DurationHint className={theme}>
            <figure>
              <img src={theme === "light" ? lightning_light : lightning} alt="lightning" />
            </figure>
            <p>
              You cannot unstake before the time you selected when staking.
            </p>
          </DurationHint> */}
          {globalData && globalData.end_date > Date.now() / 1000 ? (
            <ButtonCommon onClick={handleBuyToken}>
              <p>Buy $LEFTYTEARS </p>
              <img
                width={17}
                height={17}
                style={{
                  marginLeft: "8px",
                }}
                src={wallet_icon}
                alt="wallet"
              />
            </ButtonCommon>
          ) : (
            <ButtonCommon onClick={handleClaimToken}>
              <p>Claim $LEFTYTEARS </p>
              <img
                width={17}
                height={17}
                style={{
                  marginLeft: "8px",
                }}
                src={wallet_icon}
                alt="wallet"
              />
            </ButtonCommon>
          )}
        </div>
        <br />
        <ContentDuration>
          <ContentInnerLeft>
            <BlockSummary>
              <BlockTitle>
                <TitleCommon text="Your Data" />
              </BlockTitle>
              <AmountList>
                {DataDurationList.map((item: any, index: number) => {
                  return (
                    activeDuration === item.id && (
                      <>
                        <AmountItem key={index}>
                          <span>{item.balance.title}</span>
                          <span>{item.balance.value}</span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.staked.title}</span>
                          <span>{item.staked.value}</span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.claimable.title}</span>
                          <span>{item.claimable.value}</span>
                        </AmountItem>
                      </>
                    )
                  );
                })}
              </AmountList>
            </BlockSummary>
          </ContentInnerLeft>
          <ContentInnerRight>
            <TitleCommon text="Presale details" />
            <AmountList>
              {DataDurationList.map((item: any, index: number) => {
                return (
                  activeDuration === item.id && (
                    <>
                      <AmountItem key={index}>
                        <span>{item.duration.title}</span>
                        <span>{item.duration.value}</span>
                      </AmountItem>
                      <AmountItem key={index}>
                        <span>{item.totalSoldAmount.title}</span>
                        <span>{item.totalSoldAmount.value}</span>
                      </AmountItem>
                      <AmountItem key={index}>
                        <span>{item.presalePrice.title}</span>
                        <span>{item.presalePrice.value}</span>
                      </AmountItem>
                      <AmountItem key={index}>
                        <span>{item.launchPrice.title}</span>
                        <span>{item.launchPrice.value}</span>
                      </AmountItem>
                      <AmountItem key={index}>
                        <span>{item.softcap.title}</span>
                        <span>{item.softcap.value}</span>
                      </AmountItem>
                      <AmountItem>
                        <span>Contract address</span>
                        <a href="https://tonviewer.com/EQDHo-Zk49lhteQm96pjH-_GdhYnMNQeBALP9pWg851PrR0o">
                          <span style={{ color: "#f7f7f8" }}>
                            {shorten("EQDHo-Zk49lhteQm96pjH-_GdhYnMNQeBALP9pWg851PrR0o")}
                          </span>
                        </a>
                      </AmountItem>
                    </>
                  )
                );
              })}
            </AmountList>
          </ContentInnerRight>
        </ContentDuration>
      </ContentRightInner>
    </>
  );
};

export default Stake;
